import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { string, func } from 'prop-types';
import { get, size } from 'lodash-es';
import { urlVideoIdSelector } from 'pages/channel.page/index';
import { videoBoxRequestAction } from 'components/video-box/actions';
import { getVideoSelector } from 'components/video-box/selectors';
import { VideoComments } from 'components/video-box/video-comments';
import { MobilePage } from 'pages/mobile-page';
import { getVideoCommentsSelector, getVideoCommentsListLoadingSelector } from 'common/selectors';

const CommentsPage = ({ headerTitle, contentTitle, goBack, videoId }) => (
  <MobilePage headerTitle={headerTitle} goBack={goBack}>
    <span className="ct-comments-page__content-title">{contentTitle}</span>
    <VideoComments videoId={videoId} />
  </MobilePage>
);

CommentsPage.propTypes = {
  headerTitle: string,
  goBack: func.isRequired,
  contentTitle: string.isRequired,
};

const mapStateToProps = (state, props) => ({
  videoId: urlVideoIdSelector(state, props.match),
  videoTitle: get(getVideoSelector(state), 'title'),
  isCommentsLoading: getVideoCommentsListLoadingSelector(state),
  totalComments: size(getVideoCommentsSelector(state)),
});

const mapDispatchToProps = (dispatch) => ({
  loadVideoComments: (videoId) => dispatch(videoBoxRequestAction(videoId)),
});

const mergeProps = (stateProps, dispatchProps, props) => ({
  loadVideoComments: () => dispatchProps.loadVideoComments(stateProps.videoId),
  goBack: () => {
    props.history.go(-1);
  },
  headerTitle: stateProps.videoTitle,
  contentTitle: stateProps.isCommentsLoading ? '' : `${props.t('comments')} (${stateProps.totalComments})`,
  videoId: stateProps.videoId,
});

export const CommentsPageDecorated = compose(
  withRouter,
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(CommentsPage);
